/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '@openapi/request';
import type { GenericPaginationDto } from "@core/pages/bsc/api";
import {
  NettCommissionDto,
  NettCommissionPublishDto,
  UpdateViolationDto,
  ViolationDto, ViolationResponse
} from "@core/pages/compensation-setup/api/models/ProductionBonusDTO";

export class ProductionBonusService {

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static async retrieveListOfViolation(
    requestBody: GenericPaginationDto,
  ): Promise<any> {
    const path = `/web/api/production-bonus-setup/violation/list`;

    const result = await __request({
      method: 'POST',
      path: path,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @returns any Exports violation as CSV
   * @throws ApiError
   */
  public static async exportViolation(
  ): Promise<any> {
    const result = await __request({
      method: 'GET',
      path: `/web/api/production-bonus-setup/violation/export-csv`,
    });
    return result.body;
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static async importViolation(
    requestBody: any
  ): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/web/api/production-bonus-setup/violation/import`,
      formData: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static async createViolation(
    requestBody: ViolationDto,
  ): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/web/api/production-bonus-setup/violation`,
      body: requestBody,
    });
    return result.body;
  }
  
  /**
   * Delete a violation record by its OID.
   *
   * @param violationOid - Unique identifier of the violation record to delete
   * @returns ViolationResponse
   * @throws ApiError
   */
  public static async deleteViolationRecord(
    violationOid: string,
  ): Promise<ViolationResponse> {
    const result = await __request({
      method: 'DELETE',
      path: `/web/api/production-bonus-setup/violation/${violationOid}`,
    });
    return result.body as ViolationResponse;
  }
  
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static async createNettCommission(
    requestBody: NettCommissionDto,
  ): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/web/api/production-bonus-setup/nett-commission`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param nettCommissionOid
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static async updateNettCommission(
    nettCommissionOid: string,
    requestBody: NettCommissionDto,
  ): Promise<any> {
    const result = await __request({
      method: 'PUT',
      path: `/web/api/production-bonus-setup/nett-commission/${nettCommissionOid}`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param nettCommissionOid
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static async publishNettCommission(
    nettCommissionOid: string,
    requestBody: NettCommissionPublishDto,
  ): Promise<any> {
    const result = await __request({
      method: 'POST',
      path: `/web/api/production-bonus-setup/nett-commission/publish/${nettCommissionOid}`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param nettCommissionOid
   * @returns any
   * @throws ApiError
   */
  public static async deleteNettCommission(
    nettCommissionOid: string,
  ): Promise<any> {
    const result = await __request({
      method: 'DELETE',
      path: `/web/api/production-bonus-setup/nett-commission/${nettCommissionOid}`,
    });
    return result.body;
  }


  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static async retrieveListOfNettCommission(
    requestBody: GenericPaginationDto,
  ): Promise<any> {
    const path = `/web/api/production-bonus-setup/nett-commission/list`;

    const result = await __request({
      method: 'POST',
      path: path,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns ViolationResponse Updated Violation record successfully
   * @throws ApiError
   */
  public static async updateViolationRecord(
    violationOid:string,
    requestBody: UpdateViolationDto,
  ): Promise<ViolationResponse> {
    const result = await __request({
      method: 'PUT',
      path: `/web/api/production-bonus-setup/violation/${violationOid}`,
      body: requestBody,
    });
    return result.body;
  }

}
